import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

type ActionsContainerProps = {
    alignItems?: string;
    marginTop?: number;
};

const ActionsContainer = styled.div<ActionsContainerProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${({ alignItems }) => alignItems || 'center'};
    margin-bottom: ${gridSize()}px;
    margin-top: ${({ marginTop }) => (marginTop || marginTop === 0 ? marginTop : gridSize())}px;
`;

export default ActionsContainer;
